/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HighRiskApi} from '../api/highrisk.api';
import { switchMap, map } from 'rxjs/operators';
import { HighRiskData,HighRisk } from '../../../interfaces/masters/highrisk';

@Injectable()
export class HighRiskService extends HighRiskData {

  constructor(private api: HighRiskApi) {
    super();
  }


  list(): Observable<HighRisk[]> {
    return this.api.list();
  }

  getById(url:string): Observable<HighRisk>{
      return this.api.getById(url);
  }

  create(url: string, data:HighRisk): Observable<HighRisk> {
    return this.api.add(url,data);
  }

  update(url: string, data:HighRisk): Observable<HighRisk> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
